import React from 'react'
import { useForm } from 'react-hook-form'
import { Box, Flex, Text, Button, Link, Stack, Input, Checkbox } from '@chakra-ui/core'

interface WelcomeBodyProps {
	onSubmit: (values: { dontShow: boolean }) => void
	title: string
	text: React.ReactElement
}

const WelcomeBody: React.FC<WelcomeBodyProps> = ({ onSubmit, title, text }) => {
	const { register, handleSubmit } = useForm<{ dontShow: boolean }>()

	return (
		<Flex
			direction='column'
			maxW='600px'
			bg='rgba(255,255,255,0.74)'
			px={8}
			ml={[0, 'max(calc((100vw - 1280px)/2), 1em)']}
			py={[16, 3, 16]}
			h='100%'
			textAlign={['center', 'left']}
		>
			<Text fontFamily='Poppins' fontWeight='bold' fontSize={['3xl', '4xl']} color='brand.500' pb={8}>
				{title}
			</Text>
			<Text color='gray.800'>{text}</Text>
			<Stack spacing={4} as='form' direction='column' onSubmit={handleSubmit(onSubmit)}>
				<Button
					fontWeight='500'
					w='85%'
					mx='auto'
					variantColor='brand'
					px={8}
					rounded='20px'
					mt={[10, 6, 10]}
					mb={[10, 0, 10]}
					type='submit'
				>
					Acessar com o VIDaaS
				</Button>

				<Box as='hr' color='gray.600' mt={[4, 0, 10]} mb={4} w='80%' mx='auto' />
				<Link
					textDecoration='none'
					color='brand.500'
					href='https://ajuda.validcertificadora.com.br/certificados-em-nuvem-para-medicos'
					target='_blank'
					rel='noopener'
					_hover={{
						textDecoration: 'none',
						color: 'brand.400'
					}}
				>
					Saiba mais sobre Certificados Digitais para médicos
				</Link>
				<Link
					textDecoration='none'
					color='brand.500'
					href='https://www.vidaas.com.br/'
					target='_blank'
					rel='noopener'
					_hover={{
						textDecoration: 'none',
						color: 'brand.400'
					}}
				>
					Adquira o VIDaaS aqui
				</Link>
				<Box as='label' color='gray.800'>
					<Checkbox variantColor='brand' name='dontShow' ref={register}>
						Não exibir novamente esta página
					</Checkbox>
				</Box>
			</Stack>
		</Flex>
	)
}

export default WelcomeBody
